module.exports = __webpack_public_path__ + "static/background-343f4a88ade324a634274099954c15e4.svg";